import React from "react";
import { styles } from "./styles";
import { Document, Font, Image, Page, Text, View } from "@react-pdf/renderer";
import logo from "../../Assets/logoMerxVetorizadaBranca.png";
import clientes from "../../Assets/clientes.png";
import destaque from "../../Assets/fortlev-solar-usina-05.png";
import flagGreen from "../../Assets/flagGreen.png";
import flagYellow from "../../Assets/flagYellow.png";
import flagRedP1 from "../../Assets/flagRedP1.png";
import flagRedP2 from "../../Assets/flagRedP2.png";
import monograma from "../../Assets/monogramaBranco.png";
import Poppins from "../../Assets/fonts/Poppins-Regular.ttf";
import {
  ApeData,
  CativoData,
  EconomyData,
  LivreData,
  SimulatorData,
} from "./types";

export default function PDFSimulator({
  simulatorData,
  desconto,
  economyData,
  apeData,
  livreData,
  cativoData,
  simulationType,
}: {
  simulatorData: SimulatorData;
  desconto: number;
  economyData: EconomyData;
  apeData: ApeData;
  livreData: LivreData;
  cativoData: CativoData;
  simulationType: "varejista" | "atacadista";
}) {
  const data = new Date();
  const formatNumberToBrazilCurrency = (number: number) => {
    const formattedNumber = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);

    return formattedNumber;
  };
  const normalize = (numbers: number[]) => {
    const min = Math.min(...numbers);
    const max = Math.max(...numbers);
    const scaleA = 10;
    const scaleB = 130;

    const normalized = numbers.map(
      (x) => ((scaleB - scaleA) * (x - min)) / (max - min) + scaleA
    );
    return normalized;
  };
  const economyNormalized = normalize(
    economyData.economyAccumulated.slice(0, simulatorData.precoEnergia.length)
  );
  const monthEconomyPercent = Math.round(
    (1 -
      livreData.custos.custoTotal.comImposto /
        cativoData.custos.custoTotal.comImposto) *
      100
  );

  const volumeContrato = +(
    +(
      +simulatorData.consumoPonta.replace(".", "").replace(",", ".") +
      +simulatorData.consumoForaPonta.replace(".", "").replace(",", ".")
    ).toFixed(0) /
    1000 /
    730
  ).toFixed(6);

  // Data de validade: se antes das 16h -> hoje 18:00, senão -> amanhã 18:00
  const now = new Date();
  const validadeRaw = new Date(now);
  if (now.getHours() < 16) {
    validadeRaw.setHours(18, 0, 0, 0);
  } else {
    validadeRaw.setDate(validadeRaw.getDate() + 1);
    validadeRaw.setHours(18, 0, 0, 0);
  }

  const formatToDDMMYYYYhhmm = (d: Date) => {
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
  };

  const dataValidade = formatToDDMMYYYYhhmm(validadeRaw);

  Font.register({
    family: "Poppins",
    src: Poppins,
  });

  const hyphenationCallback = (word: string) => {
    return [word];
  };

  Font.registerHyphenationCallback(hyphenationCallback);

  return (
    <Document>
      <Page orientation="landscape" style={styles.header}>
        <View style={styles.image}>
          <View style={styles.merxImageContainer}>
            <Image style={styles.merxImage} src={logo} />
          </View>
          <View
            style={[
              {
                margin: 15,
                textAlign: "center",
                color: "#fff",
                fontSize: 20,
                top: "120px",
              },
            ]}
          >
            <Text style={{ marginBottom: 25, fontSize: 25 }}>
              Proposta indicativa {simulationType}
            </Text>
            <Text style={{ marginBottom: 10 }}>
              Cliente:{" "}
              {!!simulatorData.cliente
                ? simulatorData.cliente
                : simulatorData.cnpj}
              {""}
            </Text>
            <Text>{`${data.toLocaleDateString("pt-BR")}`}</Text>
          </View>
        </View>
      </Page>

      <Page
        orientation="landscape"
        style={{
          justifyContent: "center",
          backgroundColor: "#0a505c",
          fontFamily: "Poppins",
        }}
      >
        <View
          style={{
            flex: 1,
            flexDirection: "row",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          <View style={{ flex: 1 }}>
            <Text style={[styles.title, { marginLeft: 20, marginTop: 20 }]}>
              A Merx
            </Text>
            <View style={{ justifyContent: "center", height: "100%" }}>
              <Text style={[styles.textBody, { color: "#FFFFFF" }]}>
                Fundada em 2021, a Merx Energia surgiu a partir da análise de
                lacunas no mercado energético, identificando a escassez de mão
                de obra técnica especializada com atendimento local e ágil. A
                empresa foi estruturada para otimizar processos operacionais,
                elevar padrões de qualidade e ampliar a eficiência na execução
                de serviços e projetos elétricos.
              </Text>
            </View>
          </View>
          <View style={styles.destaque}>
            <Image src={destaque} style={styles.destaque} />
          </View>
        </View>
      </Page>

      <Page orientation="landscape">
        <View style={styles.header}>
          <Text style={styles.title}>Nossos clientes</Text>
        </View>
        <View style={styles.clients}>
          <Image src={clientes} />
        </View>
      </Page>

      <Page
        orientation="landscape"
        style={{ backgroundColor: "#0a505c", padding: 15 }}
      >
        <View>
          <Text style={styles.title}>Dados de simulação {simulationType}</Text>
          <Text style={{ fontSize: 10, marginBottom: 15, color: "#fff" }}>
            Veja os dados utilizados para fazer o estudo de viabilidade
          </Text>
        </View>
        <View style={styles.consumeColumn}>
          <View style={styles.consumeCard}>
            <Text style={styles.consumeTitle}>Dados do cliente</Text>
            <View>
              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Nome:</Text>
                <Text>
                  {!!simulatorData.cliente
                    ? simulatorData.cliente
                    : "Não informado"}
                </Text>
              </View>
              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Distribuidora:</Text>
                <Text>{simulatorData.distribuidora}</Text>
              </View>
              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Classificação:</Text>
                <Text>{`${simulatorData.grupoTarifario} -  ${simulatorData.ths}`}</Text>
              </View>
              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Demanda fora ponta:</Text>
                <Text>{simulatorData.demandaForaPonta} kW</Text>
              </View>
              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Demanda ponta:</Text>
                <Text>{simulatorData.demandaPonta} kW</Text>
              </View>
              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Consumo ponta:</Text>
                <Text>{simulatorData.consumoPonta} kWh</Text>
              </View>
              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Consumo fora ponta:</Text>
                <Text>{simulatorData.consumoForaPonta} kWh</Text>
              </View>
              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Volume:</Text>
                <Text>{volumeContrato.toString().replace(".", ",")} MWm</Text>
              </View>
            </View>
          </View>
          <View style={styles.consumeCard}>
            <Text style={styles.consumeTitle}>Custos e impostos</Text>
            <View>
              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>IPCA:</Text>
                <Text>
                  {!!simulatorData.reajusteEnergia
                    ? simulatorData.reajusteEnergia + "%"
                    : "5%"}
                </Text>
              </View>

              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Reajuste:</Text>
                <Text>
                  {!!simulatorData.reajusteDistribuidora
                    ? simulatorData.reajusteDistribuidora + "%"
                    : "7%"}
                </Text>
              </View>

              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Operacional:</Text>
                <Text>
                  R$ {formatNumberToBrazilCurrency(economyData.custoGestao)}
                </Text>
              </View>

              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>PIS/COFINS:</Text>
                <Text>
                  {(
                    +simulatorData.pis.replace(".", "").replace(",", ".") +
                    +simulatorData.cofins.replace(".", "").replace(",", ".")
                  )
                    .toFixed(2)
                    .replace(".", ",")}
                  %
                </Text>
              </View>

              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>ICMS:</Text>
                <Text>
                  {!!simulatorData.icms
                    ? simulatorData.icms + "%"
                    : "A definir"}
                </Text>
              </View>

              {simulatorData.isBateria ? (
                <>
                  <View style={styles.contactLine}>
                    <Text style={styles.contactLabel}>
                      Capacidade Bateria:{" "}
                    </Text>
                    <Text>
                      {formatNumberToBrazilCurrency(
                        +simulatorData.energiaMaximaArmazenada
                          .replace(".", "")
                          .replace(",", ".")
                      )}{" "}
                      kWh
                    </Text>
                  </View>

                  <View style={styles.contactLine}>
                    <Text style={styles.contactLabel}>Potência Bateria: </Text>
                    <Text>
                      {formatNumberToBrazilCurrency(
                        +simulatorData.potenciaBateria
                          .replace(".", "")
                          .replace(",", ".")
                      )}{" "}
                      kW
                    </Text>
                  </View>
                </>
              ) : (
                <View style={styles.contactLine}>
                  <Text style={styles.contactLabel}>Gerador: </Text>
                  <Text>
                    {simulatorData.isGerador
                      ? `R$ ${formatNumberToBrazilCurrency(
                          cativoData.custoGerador.custoTotal.comImposto
                        )}`
                      : "Não"}
                  </Text>
                </View>
              )}

              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Adequação:</Text>
                <Text>A definir</Text>
              </View>
            </View>
          </View>
          <View style={styles.consumeCard}>
            <Text style={styles.consumeTitle}>Preço energia</Text>
            <View>
              {simulatorData.precoEnergia.map((item, index) => (
                <View style={styles.contactLine} key={index}>
                  <Text style={styles.contactLabel}>
                    Preço {parseInt(economyData.economyData[0].ano) + index}:
                  </Text>
                  <Text>
                    R${" "}
                    {formatNumberToBrazilCurrency(
                      parseFloat(item.replace(".", "").replace(",", "."))
                    )}
                  </Text>
                </View>
              ))}
              <View style={styles.contactLine}>
                <Text style={styles.contactLabel}>Tipo da fonte:</Text>
                <Text>
                  {(desconto === 0 && "Sem desconto") ||
                    (desconto === 0.5 && "50% desconto") ||
                    (desconto === 1 && "100% desconto")}
                </Text>
              </View>
            </View>
          </View>
        </View>
        <View>
          <Text style={{ color: "#fff", textAlign: "justify", fontSize: 10 }}>
            {`O presente estudo tem caráter indicativo e reflete a situação operacional vigente do dia ${data.toLocaleDateString(
              "pt-BR"
            )}. Os valores de energia podem variar de acordo com os preços de mercado em constante flutuação. Ademais, os preços dos equipamentos estão sujeitos a alterações sem aviso prévio. ${"É importante ressaltar que este estudo não constitui uma proposta definitiva"}. Cabe ressaltar que os custos de operação e manutenção relacionados a usina fotovoltaica não estão contemplados neste estudo. Além disso, determinados custos adicionais não estão incluídos, como os relacionados a ultrapassagem de demanda, energia reativa e eventuais impactos decorrentes de redução ou aumento de demanda. Também não estão consideradas possíveis mudanças extraordinárias que poderiam resultar na criação de novos tributos, encargos ou subsídios. Outros custos excluídos são os relacionados a iluminação pública, bem como parcelamentos ou financiamentos de faturas referentes a meses anteriores.`}
          </Text>
        </View>
      </Page>

      <Page
        orientation="landscape"
        style={{
          padding: 15,
          justifyContent: "space-between",
          backgroundColor: "#0a505c",
        }}
      >
        <View>
          <Text style={[styles.title]}>Economia Mensal</Text>
          <Text style={{ fontSize: 10, marginBottom: 15, color: "#fff" }}>
            Veja a memória de cálculo detalhada para cada item da sua fatura e
            os valores de economia mensal no cenário atual.
          </Text>
        </View>
        <View style={styles.invoice}>
          <View style={styles.invoiceCard}>
            <Text style={{ fontFamily: "RobotoBold", marginBottom: 15 }}>
              Consumidor cativo
            </Text>
            <View style={{ justifyContent: "space-between" }}>
              <View
                style={[
                  styles.gridRow,
                  {
                    fontFamily: "RobotoBold",
                    fontSize: 12,
                  },
                ]}
              >
                <Text>Grandeza elétrica</Text>
                <Text>Grandeza faturada</Text>
                <Text>Faturado</Text>
              </View>
              <View>
                <View
                  style={[
                    styles.gridRow,
                    {
                      fontSize: 10,
                    },
                  ]}
                >
                  <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                    Demanda contratada FP
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    {cativoData.demandaForaPonta.volume.toLocaleString(
                      "pt-BR",
                      {
                        style: "decimal",
                      }
                    )}{" "}
                    kW
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    R${" "}
                    {formatNumberToBrazilCurrency(
                      cativoData.demandaForaPonta.custoTotal.comImposto
                    )}
                  </Text>
                </View>
                <View
                  style={[
                    styles.gridRow,
                    {
                      fontSize: 10,
                    },
                  ]}
                >
                  <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                    Demanda contratada P
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    {cativoData.demandaPonta.volume.toLocaleString("pt-BR", {
                      style: "decimal",
                    })}{" "}
                    kW
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    R${" "}
                    {formatNumberToBrazilCurrency(
                      cativoData.demandaPonta.custoTotal.comImposto
                    )}
                  </Text>
                </View>
                <View
                  style={[
                    styles.gridRow,
                    {
                      fontSize: 10,
                    },
                  ]}
                >
                  <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                    Demanda ultrapassagem FP
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    {cativoData.demandaForaPontaUltrapassagem.volume.toLocaleString(
                      "pt-BR",
                      {
                        style: "decimal",
                      }
                    )}{" "}
                    kW
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    R${" "}
                    {formatNumberToBrazilCurrency(
                      cativoData.demandaForaPontaUltrapassagem.custoTotal
                        .comImposto
                    )}
                  </Text>
                </View>
                <View
                  style={[
                    styles.gridRow,
                    {
                      fontSize: 10,
                    },
                  ]}
                >
                  <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                    Demanda ultrapassagem P
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    {cativoData.demandaPontaUltrapassagem.volume.toLocaleString(
                      "pt-BR",
                      {
                        style: "decimal",
                      }
                    )}{" "}
                    kW
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    R${" "}
                    {formatNumberToBrazilCurrency(
                      cativoData.demandaPontaUltrapassagem.custoTotal.comImposto
                    )}
                  </Text>
                </View>
                <View
                  style={[
                    styles.gridRow,
                    {
                      fontSize: 10,
                    },
                  ]}
                >
                  <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                    TUSD FP
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    {cativoData.consumoForaPonta.volume.toLocaleString(
                      "pt-BR",
                      {
                        style: "decimal",
                      }
                    )}{" "}
                    kWh
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    R${" "}
                    {formatNumberToBrazilCurrency(
                      cativoData.consumoForaPonta.custoTotal.comImposto
                    )}
                  </Text>
                </View>
                <View
                  style={[
                    styles.gridRow,
                    {
                      fontSize: 10,
                    },
                  ]}
                >
                  <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                    TUSD P
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    {cativoData.consumoPonta.volume.toLocaleString("pt-BR", {
                      style: "decimal",
                    })}{" "}
                    kWh
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    R${" "}
                    {formatNumberToBrazilCurrency(
                      cativoData.consumoPonta.custoTotal.comImposto
                    )}
                  </Text>
                </View>
                <View
                  style={[
                    styles.gridRow,
                    {
                      fontSize: 10,
                    },
                  ]}
                >
                  <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                    TE FP
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    {cativoData.energiaForaPonta.volume.toLocaleString(
                      "pt-BR",
                      {
                        style: "decimal",
                      }
                    )}{" "}
                    kWh
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    R${" "}
                    {formatNumberToBrazilCurrency(
                      cativoData.energiaForaPonta.custoTotal.comImposto
                    )}
                  </Text>
                </View>
                <View
                  style={[
                    styles.gridRow,
                    {
                      fontSize: 10,
                    },
                  ]}
                >
                  <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                    TE P
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    {cativoData.energiaPonta.volume.toLocaleString("pt-BR", {
                      style: "decimal",
                    })}{" "}
                    kWh
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    R${" "}
                    {formatNumberToBrazilCurrency(
                      cativoData.energiaPonta.custoTotal.comImposto
                    )}
                  </Text>
                </View>
                <View
                  style={[
                    styles.gridRow,
                    {
                      fontSize: 10,
                    },
                  ]}
                >
                  <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                    Gerador
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    {cativoData.custoGerador.volume.toLocaleString("pt-BR", {
                      style: "decimal",
                    })}{" "}
                    kWh
                  </Text>
                  <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                    R${" "}
                    {formatNumberToBrazilCurrency(
                      cativoData.custoGerador.custoTotal.comImposto
                    )}
                  </Text>
                </View>
              </View>
            </View>
            <View>
              <View
                style={[
                  styles.gridRow,
                  { fontFamily: "RobotoBold", marginTop: 20, fontSize: 12 },
                ]}
              >
                <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                  Total
                </Text>
                <View style={styles.gridColumn} />
                <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    cativoData.custos.custoTotal.comImposto
                  )}
                </Text>
              </View>
            </View>
          </View>
          <View style={styles.invoiceCard}>
            <Text style={{ fontFamily: "RobotoBold", marginBottom: 15 }}>
              Consumidor livre
            </Text>
            <View style={{ justifyContent: "space-between", flex: 1 }}>
              <View>
                <View
                  style={[
                    styles.gridRow,
                    {
                      fontFamily: "RobotoBold",
                      fontSize: 12,
                    },
                  ]}
                >
                  <Text>Grandeza elétrica</Text>
                  <Text>Grandeza faturada</Text>
                  <Text>Faturado</Text>
                </View>
                <View>
                  <View
                    style={[
                      styles.gridRow,
                      {
                        fontSize: 10,
                      },
                    ]}
                  >
                    <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                      Demanda contratada FP
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      {livreData.demandaForaPonta.volume.toLocaleString(
                        "pt-BR",
                        {
                          style: "decimal",
                        }
                      )}{" "}
                      kW
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      R${" "}
                      {formatNumberToBrazilCurrency(
                        livreData.demandaForaPonta.custoTotal.comImposto
                      )}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.gridRow,
                      {
                        fontSize: 10,
                      },
                    ]}
                  >
                    <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                      Demanda contratada P
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      {livreData.demandaPonta.volume.toLocaleString("pt-BR", {
                        style: "decimal",
                      })}{" "}
                      kW
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      R${" "}
                      {formatNumberToBrazilCurrency(
                        livreData.demandaPonta.custoTotal.comImposto
                      )}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.gridRow,
                      {
                        fontSize: 10,
                      },
                    ]}
                  >
                    <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                      TUSD FP
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      {livreData.consumoForaPonta.volume.toLocaleString(
                        "pt-BR",
                        {
                          style: "decimal",
                        }
                      )}{" "}
                      kWh
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      R${" "}
                      {formatNumberToBrazilCurrency(
                        livreData.consumoForaPonta.custoTotal.comImposto
                      )}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.gridRow,
                      {
                        fontSize: 10,
                      },
                    ]}
                  >
                    <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                      TUSD P
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      {livreData.consumoPonta.volume.toLocaleString("pt-BR", {
                        style: "decimal",
                      })}{" "}
                      kWh
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      R${" "}
                      {formatNumberToBrazilCurrency(
                        livreData.consumoPonta.custoTotal.comImposto
                      )}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.gridRow,
                      {
                        fontSize: 10,
                      },
                    ]}
                  >
                    <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                      Total energia ACL
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      {(
                        livreData.consumoForaPonta.volume +
                        livreData.consumoPonta.volume
                      ).toLocaleString("pt-BR", {
                        style: "decimal",
                      })}{" "}
                      kWh
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      R${" "}
                      {formatNumberToBrazilCurrency(
                        livreData.custoEnergia.custoTotal.comImposto
                      )}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.gridRow,
                      {
                        fontSize: 10,
                      },
                    ]}
                  >
                    <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                      Benefício tarifário
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      {" "}
                      -{" "}
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      R${" "}
                      {formatNumberToBrazilCurrency(
                        livreData.beneficioTarifario.custos.custoTotal
                          .comImposto
                      )}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.gridRow,
                      {
                        fontSize: 10,
                      },
                    ]}
                  >
                    <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                      Encargos
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      {" "}
                      -{" "}
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      R${" "}
                      {formatNumberToBrazilCurrency(
                        livreData.encargos.custos.custoTotal.comImposto
                      )}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.gridRow,
                      {
                        fontSize: 10,
                      },
                    ]}
                  >
                    <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                      Custo operacional e CCEE
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      {" "}
                      -{" "}
                    </Text>
                    <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                      R$ {formatNumberToBrazilCurrency(livreData.operacional)}
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={[
                  styles.gridRow,
                  { fontFamily: "RobotoBold", marginTop: 20, fontSize: 12 },
                ]}
              >
                <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                  Total
                </Text>
                <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    livreData.custos.custoTotal.comImposto
                  )}
                </Text>
              </View>
            </View>
          </View>
        </View>
        <View style={styles.invoice}>
          <View style={styles.invoiceCard}>
            <Text style={{ marginBottom: 5 }}>Custo Cativo</Text>
            <Text style={{ fontFamily: "RobotoBold" }}>
              R${" "}
              {formatNumberToBrazilCurrency(
                cativoData.custos.custoTotal.comImposto
              )}
            </Text>
          </View>
          <View style={styles.invoiceCard}>
            <Text style={{ marginBottom: 5 }}>Custo Livre</Text>
            <Text style={{ fontFamily: "RobotoBold" }}>
              R${" "}
              {formatNumberToBrazilCurrency(
                livreData.custos.custoTotal.comImposto
              )}
            </Text>
          </View>
          <View style={styles.invoiceCard}>
            <Text style={{ marginBottom: 5 }}>Economia Mensal</Text>
            <View
              style={{ flexDirection: "row", justifyContent: "space-between" }}
            >
              <Text style={{ fontFamily: "RobotoBold" }}>
                R${" "}
                {formatNumberToBrazilCurrency(
                  cativoData.custos.custoTotal.comImposto -
                    livreData.custos.custoTotal.comImposto
                )}
              </Text>
              <Text
                style={{
                  color: monthEconomyPercent >= 0 ? "#1fa824" : "#f91010",
                  fontFamily: "RobotoBold",
                }}
              >
                {monthEconomyPercent}%
              </Text>
            </View>
          </View>
        </View>
      </Page>

      <Page
        orientation="landscape"
        style={{
          padding: 15,
          justifyContent: "space-between",
          backgroundColor: "#0a505c",
        }}
      >
        <View>
          <Text style={styles.title}>
            Comparação de preços entre as bandeiras
          </Text>
          <Text style={{ fontSize: 10, marginBottom: 15, color: "#fff" }}>
            Veja a comparação de preços entre as bandeiras tarifárias presentes
            no mercado cativo.
          </Text>
        </View>
        <View style={{ flex: 1, justifyContent: "center" }}>
          <View
            style={{
              flexDirection: "row",
              color: "#fff",
              fontFamily: "RobotoBold",
              fontSize: 22,
            }}
          >
            <View style={{ flex: 0.5 }} />
            <Text style={{ flex: 1, textAlign: "center" }}>Custo Cativo</Text>
            <Text style={{ flex: 1, textAlign: "center" }}>
              Custo Livre (MERX)
            </Text>
            <Text style={{ flex: 1, textAlign: "center" }}>Economia</Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View
              style={[
                styles.invoiceCard,
                { flex: 0.5, alignItems: "center", padding: 5 },
              ]}
            >
              <Image src={flagGreen} style={{ width: 50 }} />
              <Text style={{ fontSize: 10 }}>Bandeira verde</Text>
            </View>
            <View
              style={[
                styles.invoiceCard,
                { justifyContent: "center", alignItems: "center" },
              ]}
            >
              <Text style={{ fontFamily: "RobotoBold" }}>
                R${" "}
                {formatNumberToBrazilCurrency(
                  cativoData.custos.custoTotal.comImposto
                )}
              </Text>
            </View>
            <View
              style={[
                styles.invoiceCard,
                { justifyContent: "center", alignItems: "center" },
              ]}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={{ fontFamily: "RobotoBold" }}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    livreData.custos.custoTotal.comImposto
                  )}
                </Text>
              </View>
            </View>
            <View style={[styles.invoiceCard, { justifyContent: "center" }]}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={{ fontFamily: "RobotoBold" }}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    cativoData.custos.custoTotal.comImposto -
                      livreData.custos.custoTotal.comImposto
                  )}
                </Text>
                <Text
                  style={{
                    color: true ? "#1fa824" : "#f91010",
                    fontFamily: "RobotoBold",
                  }}
                >
                  {monthEconomyPercent}%
                </Text>
              </View>
            </View>
          </View>

          <View style={{ flexDirection: "row" }}>
            <View
              style={[
                styles.invoiceCard,
                { flex: 0.5, alignItems: "center", padding: 5 },
              ]}
            >
              <Image src={flagYellow} style={{ width: 50 }} />
              <Text style={{ fontSize: 10 }}>Bandeira amarela</Text>
            </View>
            <View
              style={[
                styles.invoiceCard,
                { justifyContent: "center", alignItems: "center" },
              ]}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={{ fontFamily: "RobotoBold" }}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    cativoData.valoresBandeiras.custoTotal.amarela
                  )}
                </Text>
              </View>
            </View>
            <View
              style={[
                styles.invoiceCard,
                { justifyContent: "center", alignItems: "center" },
              ]}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={{ fontFamily: "RobotoBold" }}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    livreData.custos.custoTotal.comImposto
                  )}
                </Text>
              </View>
            </View>
            <View style={[styles.invoiceCard, { justifyContent: "center" }]}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={{ fontFamily: "RobotoBold" }}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    cativoData.valoresBandeiras.custoTotal.amarela -
                      livreData.custos.custoTotal.comImposto
                  )}
                </Text>
                <Text
                  style={{
                    color: true ? "#1fa824" : "#f91010",
                    fontFamily: "RobotoBold",
                  }}
                >
                  {Math.round(
                    (1 -
                      livreData.custos.custoTotal.comImposto /
                        cativoData.valoresBandeiras.custoTotal.amarela) *
                      100
                  )}
                  %
                </Text>
              </View>
            </View>
          </View>

          <View style={{ flexDirection: "row" }}>
            <View
              style={[
                styles.invoiceCard,
                { flex: 0.5, alignItems: "center", padding: 5 },
              ]}
            >
              <Image src={flagRedP1} style={{ width: 50 }} />
              <Text style={{ fontSize: 10 }}>Bandeira vermelha P1</Text>
            </View>
            <View
              style={[
                styles.invoiceCard,
                { justifyContent: "center", alignItems: "center" },
              ]}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={{ fontFamily: "RobotoBold" }}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    cativoData.valoresBandeiras.custoTotal.vermelhaP1
                  )}
                </Text>
              </View>
            </View>
            <View
              style={[
                styles.invoiceCard,
                { justifyContent: "center", alignItems: "center" },
              ]}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={{ fontFamily: "RobotoBold" }}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    livreData.custos.custoTotal.comImposto
                  )}
                </Text>
              </View>
            </View>
            <View style={[styles.invoiceCard, { justifyContent: "center" }]}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={{ fontFamily: "RobotoBold" }}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    cativoData.valoresBandeiras.custoTotal.vermelhaP1 -
                      livreData.custos.custoTotal.comImposto
                  )}
                </Text>
                <Text
                  style={{
                    color: true ? "#1fa824" : "#f91010",
                    fontFamily: "RobotoBold",
                  }}
                >
                  {Math.round(
                    (1 -
                      livreData.custos.custoTotal.comImposto /
                        cativoData.valoresBandeiras.custoTotal.vermelhaP1) *
                      100
                  )}
                  %
                </Text>
              </View>
            </View>
          </View>

          <View style={{ flexDirection: "row" }}>
            <View
              style={[
                styles.invoiceCard,
                { flex: 0.5, alignItems: "center", padding: 5 },
              ]}
            >
              <Image src={flagRedP2} style={{ width: 50 }} />
              <Text style={{ fontSize: 10 }}>Bandeira vermelha P2</Text>
            </View>
            <View
              style={[
                styles.invoiceCard,
                { justifyContent: "center", alignItems: "center" },
              ]}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={{ fontFamily: "RobotoBold" }}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    cativoData.valoresBandeiras.custoTotal.vermelhaP2
                  )}
                </Text>
              </View>
            </View>
            <View
              style={[
                styles.invoiceCard,
                { justifyContent: "center", alignItems: "center" },
              ]}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={{ fontFamily: "RobotoBold" }}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    livreData.custos.custoTotal.comImposto
                  )}
                </Text>
              </View>
            </View>
            <View style={[styles.invoiceCard, { justifyContent: "center" }]}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={{ fontFamily: "RobotoBold" }}>
                  R${" "}
                  {formatNumberToBrazilCurrency(
                    cativoData.valoresBandeiras.custoTotal.vermelhaP2 -
                      livreData.custos.custoTotal.comImposto
                  )}
                </Text>
                <Text
                  style={{
                    color: true ? "#1fa824" : "#f91010",
                    fontFamily: "RobotoBold",
                  }}
                >
                  {Math.round(
                    (1 -
                      livreData.custos.custoTotal.comImposto /
                        cativoData.valoresBandeiras.custoTotal.vermelhaP2) *
                      100
                  )}
                  %
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>

      <Page
        orientation="landscape"
        style={{
          padding: 15,
          backgroundColor: "#0a505c",
        }}
      >
        <View>
          <Text style={[styles.title]}>Economia Anual</Text>
          <Text style={{ fontSize: 10, marginBottom: 20, color: "#fff" }}>
            Veja a projeção de economia anual com o reajuste das tarifas e com o
            preço de energia atualizada para os próximos anos.
          </Text>
        </View>
        {economyData.economyData.map(
          (preco, index) =>
            index < 5 &&
            index < simulatorData.quantidadeAnos && (
              <View style={{ fontSize: 13, marginBottom: 20 }}>
                <Text style={[styles.title, { fontSize: 18 }]}>
                  {preco.ano}
                </Text>
                <View style={styles.invoice}>
                  <View style={styles.invoiceCard}>
                    <Text style={{ marginBottom: 5 }}>Custo Cativo</Text>
                    <Text style={{ fontFamily: "RobotoBold" }}>
                      R$ {formatNumberToBrazilCurrency(preco.firstTotal)}
                    </Text>
                  </View>
                  <View style={styles.invoiceCard}>
                    <Text style={{ marginBottom: 5 }}>Custo Livre</Text>
                    <Text style={{ fontFamily: "RobotoBold" }}>
                      R$ {formatNumberToBrazilCurrency(preco.secondTotal)}
                    </Text>
                  </View>
                  <View style={styles.invoiceCard}>
                    <Text style={{ marginBottom: 5 }}>Economia mensal</Text>
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text style={{ fontFamily: "RobotoBold" }}>
                        R$ {formatNumberToBrazilCurrency(preco.economia)}
                      </Text>
                      <Text
                        style={{
                          color: preco.economiaPct >= 0 ? "#1fa824" : "#f91010",
                          fontFamily: "RobotoBold",
                        }}
                      >
                        {Math.round(preco.economiaPct * 100)}%
                      </Text>
                    </View>
                  </View>
                  <View style={styles.invoiceCard}>
                    <Text style={{ marginBottom: 5 }}>Economia anual</Text>
                    <Text style={{ fontFamily: "RobotoBold" }}>
                      R$ {formatNumberToBrazilCurrency(preco.economiaAnual)}
                    </Text>
                  </View>
                </View>
              </View>
            )
        )}
      </Page>

      {economyData.economyData.length > 5 && simulatorData.quantidadeAnos > 5 && (
        <Page
          orientation="landscape"
          style={{
            padding: 15,
            backgroundColor: "#0a505c",
          }}
        >
          <View>
            <Text style={[styles.title]}>Economia Anual</Text>
            <Text style={{ fontSize: 10, marginBottom: 20, color: "#fff" }}>
              Veja a projeção de economia anual com o reajuste das tarifas e com
              o preço de energia atualizada para os próximos anos.
            </Text>
          </View>
          {economyData.economyData.map(
            (preco, index) =>
              index >= 5 &&
              index < simulatorData.quantidadeAnos && (
                <View
                  style={{
                    fontSize: 13,
                    marginBottom: 20,
                  }}
                >
                  <Text style={[styles.title, { fontSize: 18 }]}>
                    {preco.ano}
                  </Text>
                  <View style={styles.invoice}>
                    <View style={styles.invoiceCard}>
                      <Text style={{ marginBottom: 5 }}>Custo Cativo</Text>
                      <Text style={{ fontFamily: "RobotoBold" }}>
                        R$ {formatNumberToBrazilCurrency(preco.firstTotal)}
                      </Text>
                    </View>
                    <View style={styles.invoiceCard}>
                      <Text style={{ marginBottom: 5 }}>Custo Livre</Text>
                      <Text style={{ fontFamily: "RobotoBold" }}>
                        R$ {formatNumberToBrazilCurrency(preco.secondTotal)}
                      </Text>
                    </View>
                    <View style={styles.invoiceCard}>
                      <Text style={{ marginBottom: 5 }}>Economia mensal</Text>
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text style={{ fontFamily: "RobotoBold" }}>
                          R$ {formatNumberToBrazilCurrency(preco.economia)}
                        </Text>
                        <Text
                          style={{
                            color:
                              preco.economiaPct >= 0 ? "#1fa824" : "#f91010",
                            fontFamily: "RobotoBold",
                          }}
                        >
                          {Math.round(preco.economiaPct * 100)}%
                        </Text>
                      </View>
                    </View>
                    <View style={styles.invoiceCard}>
                      <Text style={{ marginBottom: 5 }}>Economia anual</Text>
                      <Text style={{ fontFamily: "RobotoBold" }}>
                        R$ {formatNumberToBrazilCurrency(preco.economiaAnual)}
                      </Text>
                    </View>
                  </View>
                </View>
              )
          )}
        </Page>
      )}

      <Page
        orientation="landscape"
        style={{
          padding: 15,
          justifyContent: "space-between",
          backgroundColor: "#0a505c",
        }}
      >
        <Text style={styles.title}>Resumo</Text>
        <View
          style={{
            flex: 1,
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <View
            style={{
              width: "50%",
              height: "100%",
              padding: 15,
              fontSize: 12,
              borderTopLeftRadius: 10,
              borderBottomLeftRadius: 10,
              backgroundColor: "#fff",
            }}
          >
            <Text
              style={[
                styles.consumeTitle,
                {
                  textAlign: "center",
                },
              ]}
            >
              Detalhes da fatura
            </Text>
            <View
              style={[
                styles.gridRow,
                {
                  fontFamily: "RobotoBold",
                  alignItems: "center",
                },
              ]}
            >
              <Text style={styles.gridColumn}>CUSTOS</Text>
              <View style={styles.gridColumn}>
                <Text>CUSTO CATIVO</Text>
              </View>
              <View style={styles.gridColumn}>
                <Text style={styles.gridColumn}>{"CUSTO LIVRE"}</Text>
                <Text
                  style={{
                    fontSize: 9,
                    fontFamily: "RobotoRegular",
                  }}
                >
                  (MERX)
                </Text>
              </View>
            </View>

            <View style={styles.gridRow}>
              <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                Distribuidora
              </Text>
              <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                R${" "}
                {formatNumberToBrazilCurrency(
                  cativoData.custoConexao.custoTotal.comImposto
                )}
              </Text>
              <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                R${" "}
                {formatNumberToBrazilCurrency(
                  livreData.custoConexao.custoTotal.comImposto
                )}
              </Text>
            </View>

            <View style={styles.gridRow}>
              <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                Energia
              </Text>
              <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                R${" "}
                {formatNumberToBrazilCurrency(
                  cativoData.custoEnergia.custoTotal.comImposto +
                    cativoData.custoGerador.custoTotal.comImposto
                )}
              </Text>
              <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                R${" "}
                {formatNumberToBrazilCurrency(
                  livreData.custoEnergia.custoTotal.comImposto
                )}
              </Text>
            </View>

            <View style={styles.gridRow}>
              <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                Operacional
              </Text>
              <Text style={styles.gridColumn}>-</Text>
              <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                R$ {formatNumberToBrazilCurrency(livreData.operacional)}
              </Text>
            </View>

            <View style={styles.gridRow}>
              <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                Encargos
              </Text>
              <Text style={styles.gridColumn}>-</Text>
              <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                R${" "}
                {formatNumberToBrazilCurrency(
                  livreData.encargos.custos.custoTotal.comImposto
                )}
              </Text>
            </View>

            <View
              style={[
                styles.gridRow,
                { fontFamily: "RobotoBold", fontSize: 14, marginTop: 15 },
              ]}
            >
              <Text style={[styles.gridColumn, { textAlign: "left" }]}>
                TOTAL
              </Text>
              <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                R${" "}
                {formatNumberToBrazilCurrency(
                  cativoData.custos.custoTotal.comImposto
                )}
              </Text>
              <Text style={[styles.gridColumn, { textAlign: "right" }]}>
                R${" "}
                {formatNumberToBrazilCurrency(
                  livreData.custos.custoTotal.comImposto
                )}
              </Text>
            </View>
          </View>

          <View
            style={{
              alignItems: "center",
              justifyContent: "space-between",
              width: "50%",
              height: "100%",
              padding: 15,
              borderTopRightRadius: 10,
              borderBottomRightRadius: 10,
              backgroundColor: "#fff",
            }}
          >
            <Text style={styles.consumeTitle}>Economia anual acumulada</Text>
            <View style={{ flexDirection: "row", alignItems: "flex-end" }}>
              {economyData.economyAccumulated.map(
                (value, index) =>
                  index < 5 &&
                  index < simulatorData.quantidadeAnos && (
                    <View style={styles.economy}>
                      <Text style={{ marginBottom: 5, fontSize: 9 }}>
                        {" "}
                        R$ {formatNumberToBrazilCurrency(value)}
                      </Text>
                      <View
                        style={[
                          styles.bar,
                          {
                            height: value <= 0 ? 20 : economyNormalized[index],
                            backgroundColor: value <= 0 ? "#f91010" : "#0a505c",
                            marginBottom: 5,
                          },
                        ]}
                      />
                      <Text>{economyData.economyData[index].ano}</Text>
                    </View>
                  )
              )}
            </View>
          </View>
        </View>
      </Page>

      <Page orientation="landscape" style={styles.header}>
        <View
          style={{
            color: "#fff",
            alignItems: "center",
          }}
        >
          <View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "flex-end",
                marginBottom: 20,
              }}
            >
              <Image src={monograma} style={{ width: 40, marginRight: 15 }} />
              <Text style={[styles.title, { marginBottom: 20 }]}>Contato</Text>
            </View>
            <View style={[styles.contactLine, { fontSize: 20 }]}>
              <Text style={[styles.contactLabel, { fontSize: 25 }]}>
                Localizado em:
              </Text>
              <Text>Torre Cícero Dias - Centro Empresarial Queiroz Galvão</Text>
            </View>
            <View style={[styles.contactLine, { fontSize: 20 }]}>
              <Text style={[styles.contactLabel, { fontSize: 25 }]}>
                Endereço:
              </Text>
              <Text>
                R. Padre Carapuceiro, 858 - Boa Viagem, Recife - PE, 51020-280
              </Text>
            </View>
            <View style={[styles.contactLine, { fontSize: 20 }]}>
              <Text style={[styles.contactLabel, { fontSize: 25 }]}>
                Telefones:
              </Text>
              <Text>(81) 98853-5303</Text>
            </View>
            <Text style={[styles.contactLine, { fontSize: 20 }]}>
              comercial@merxenergia.com.br
            </Text>
            <Text style={[styles.contactLine, { fontSize: 20 }]}>
              www.merxenergia.com.br
            </Text>
          </View>
        </View>
      </Page>
      <Page orientation="landscape" style={{ padding: 15 }}>
        <View>
          <View>
            <Text style={{ fontFamily: "RobotoBold", fontSize: 13 }}>
              Compromisso de assinatura do contrato
            </Text>
            <Text style={{ textAlign: "justify", fontSize: 12 }}>
              Caso a presente proposta seja aceita pelo Comprador no prazo de
              validade aqui previsto, esta passará a ser vinculante entre o
              Comprador e o Vendedor, constituindo um compromisso firme,
              irretratável e irrevogável, sendo que o Comprador deverá firmar
              com o Vendedor o Contrato de Compra e Venda de Energia Elétrica
              ("CCVE") com as condições mínimas descritas na presente Proposta.
            </Text>
            <Text style={{ textAlign: "justify", fontSize: 12, marginTop: 10 }}>
              Após o aceite desta Proposta e até a assinatura do CCVE, caso o
              Vendedor ou o Comprador descumpra qualquer das obrigações
              previstas nesta Proposta, especialmente se recusar ou criar óbice
              à assinatura CCVE, incorrerá em multa ao descumpridor no valor
              correspondente a 100% (cem por cento) do valor total da
              contratação, considerando o seguinte cálculo:
            </Text>
            <Text style={{ fontSize: 12, marginTop: 10 }}>
              Multa = Volume de energia previsto nesta Proposta x Preço previsto
              nesta Proposta
            </Text>
          </View>
          <View>
            {/* <Text
              style={{ fontFamily: "RobotoBold", fontSize: 13, marginTop: 15 }}
            >
              Condições Gerais da Proposta
            </Text> */}
            {/* <Text style={{ textAlign: "justify", fontSize: 12 }}>
              Mediante o aceite desta proposta, as Partes se obrigam à
              formalização do correspondente Contrato de Compra e Venda de
              Energia Elétrica contemplando, porém não se restrigindo a todos os
              itens aqui relacionados, sob pena de incorrer na multa de natureza
              não compensatória no valor de 30% (trinta por cento) do resultado
              da multiplicação do volume de Energia Contratada pelo Preço, sendo
              o termo de fechamento reconhecido pelas Partes como título
              executivo, na forma do artigo 784, III, do Código de Processo
              Civil Brasileiro.
            </Text>
            <Text style={{ textAlign: "justify", fontSize: 12, marginTop: 10 }}>
              Eventuais controvérsias em torno da presente proposta e seu aceite
              serão solucionadas no âmbito da Arbitragem do Setor Elétrico,
              prioritariamente, e do Poder Judiciário, sendo, para tanto e se
              for o caso, eleito o foro da cidade de São Paulo.
            </Text> */}
            <Text
              style={{
                textAlign: "justify",
                fontSize: 12,
                marginTop: 10,
                fontWeight: "bold",
              }}
            >
              Proposta Indicativa - Validade até {dataValidade}h
            </Text>
          </View>
        </View>
        <View>
          <View style={{ alignItems: "center", marginTop: 150 }}>
            <Text>_______________________</Text>
            <Text style={{ fontSize: 12, marginTop: 2 }}>
              {simulatorData.cliente}
            </Text>
            <Text style={{ fontSize: 12, marginTop: 2 }}>
              {simulatorData.cnpj}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
}
